class Errors {
  /**
     * Create a new Errors instance.
     */
  constructor () {
    this.errors = {}
  }

  /**
     * Determine if an errors exists for the given field.
     *
     * @param {string} field
     */
  has (field) {
    // eslint-disable-next-line no-prototype-builtins
    return this.errors.hasOwnProperty(field)
  }

  /**
     * Determine if we have any errors.
     */
  any () {
    return Object.keys(this.errors).length > 0
  }

  /**
     * Retrieve the error message for a field.
     *
     * @param {string} field
     * @param {boolean} isArray
     */
  get (field, isArray = false) {
    if (isArray) {
      const regex = new RegExp(`^${field.replace('.', '\\.')}\\.\\d+$`)
      const errorKey = Object.keys(this.errors).find(key => regex.test(key))

      if (this.errors[errorKey]) {
        return this.errors[errorKey][0]
      }
    }

    if (this.errors[field]) {
      return this.errors[field][0]
    }
  }

  /**
     * Record the new errors.
     *
     * @param {object} errors
     */
  record (errors) {
    this.errors = errors
  }

  /**
     * Clear one or all error fields.
     *
     * @param {string|null} field
     */
  clear (field) {
    if (field) {
      delete this.errors[field]
      return
    }

    this.errors = {}
  }

  all () {
    const errorTexts = []
    for (const [k, v] of Object.entries(this.errors)) {
      console.log(k)
      errorTexts.push(v[0])
    }
    return errorTexts
  }
}

export default Errors
